import * as React from 'react';
import { Box, Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { createProgramAsync } from './ProgramStore/programStoreSlice';
import useToast from '../../../hooks/useToast';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import useLoader from '../../../hooks/useLoader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  fontFamily: 'Rubik',
};

const AddProgramForm = ({ fetchData, handleClose }) => {
  const [programName, setProgramName] = React.useState(null);
  const [programDescription, setProgramDescription] = React.useState(null);
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();

  const addProgram = async () => {
    try {
      handleLoader(true);
      let payload = {
        name: programName,
        description: programDescription,
      };
      dispatch(createProgramAsync(payload))
        .unwrap()
        .then((res) => {
          if (res) {
            console.log({ resAdded: res });
            handleLoader(false);
            SuccessToast('Program added successfully.');
            fetchData();
          } else {
            handleLoader(false);
          }
          handleClose();
        });
    } catch (error) {
      handleLoader(false);
      ErrorToast('Program could not be added. Please try again!');
    }
  };

  return (
    <Box sx={style}>
      <Box sx={{ fontSize: 18, fontWeight: 'bold' }}>Add a program</Box>
      <Box alignItems="center" mt={2}>
        <Box my={2}>
          <BuzzInput
            type="text"
            name="email"
            required
            placeholder="Program name"
            label="Program Name"
            value={programName}
            onChange={(e) => setProgramName(e.target.value)}
          />
        </Box>

        <Box my={2} width="100%">
          <Box mb={1}>
            Program Description <span style={{ color: 'red' }}>*</span>
          </Box>
          <TextField
            variant="outlined"
            multiline
            rows={6}
            rowsMax={6}
            value={programDescription}
            onChange={(e) => setProgramDescription(e.target.value)}
            size="small"
            fullWidth
          />
        </Box>
      </Box>
      <Button variant="contained" color="primary" onClick={addProgram}>
        Add program
      </Button>
    </Box>
  );
};

export default AddProgramForm;
